import React, { useEffect, useState } from "react";
import { capitalizeFirstLetter } from "./utilities/helpers";

import { Helmet } from "react-helmet-async";
import Portal from "./components/Portal";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";


const isProduction = process.env.NODE_ENV === 'production';

const App = () => {
	const [client, setClient] = useState("");
	const [language, setLanguage] = useState("");
	const [enc, setEnc] = useState(null);

	useEffect(() => {
		const loadTheme = async () => {
			const currentUrl = window.location.href.replace(/^https?:\/\//, "");

			if (
				currentUrl.includes("localhost") ||
				currentUrl.includes("127.0.0.1")
			) {
				setTheme("hertz", window.location.href);
			} else {
				let urlParts = currentUrl.split(".");
				if (urlParts[0] === "test" || urlParts[0] === "stage") {
					setTheme("hertz", window.location.href);
				} else {
					setTheme(urlParts[0].toLowerCase(), window.location.href);
				}
			}

			const search = window.location.search;
			let params = new URLSearchParams(search);
			let enc = params.get('enc');
			let lan = params.get('lan') || "en";
			const userLanguage = navigator.language || navigator.userLanguage;
			const primaryLanguage = userLanguage.split("-")[0];
			setLanguage(lan || primaryLanguage);
			if (enc)
				setEnc(enc);
		};

		const setTheme = (client, currentUrl) => {
			setClient(client);
			const additionalCssLink = document.createElement("link");
			additionalCssLink.rel = "stylesheet";
			additionalCssLink.type = "text/css";
			additionalCssLink.href = `/themes/${client}/style.css`;

			//<link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
			const iconLink = document.createElement("link");
			iconLink.rel = "icon";
			iconLink.type = "image/png";
			iconLink.href = `${currentUrl}/themes/${client}/favicon.png`;

			document.getElementsByTagName('head')[0].appendChild(iconLink);
			document.getElementsByTagName('head')[0].appendChild(additionalCssLink);

			document.title = `Fines Portal ${capitalizeFirstLetter(client)}`;
		};

		loadTheme();
	}, []);

	return (
		<div className="App">
			<Helmet>
				{/* {isProduction &&
					<meta
						httpEquiv="Content-Security-Policy"
						content={`
						default-src 'self' https://api.finesportal.com;
						script-src 'self';
						img-src https://*.finesportal.com;
						media-src https://*.finesportal.com;
					`}
					></meta>
				} */}
			</Helmet>
			<Portal client={client} defaultLanguage={language} enc={enc} />
		</div>
	);
};

export default App;
